import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import qs from 'qs';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import {
  addComment,
  clearComments,
  deleteComment,
  fetchComments,
  loadMoreComments,
  updateComment,
} from '../routines/viceRoutine';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

const VICE_URL = `${envConfig.APIG_URL}vice`;
export function* fetchCommentBySourceIdSaga({ payload }) {
  const { context, contextId, paginationParams, callbackFn } = payload;

  try {
    const response = yield call(
      request,
      `${VICE_URL}/comment?context=${context}&contextId=${contextId}&${qs.stringify(
        paginationParams
      )}`
    );
    yield put(
      fetchComments.success({
        response: response.data,
        order: paginationParams.order,
        context,
        contextId,
      })
    );
    if (callbackFn) {
      callbackFn({
        ...response.data,
        order: paginationParams.order,
        orderBy: paginationParams.orderBy,
        context,
        contextId,
      });
    }
  } catch (error) {
    yield put(fetchComments.failure({ error }));
  } finally {
    yield put(fetchComments.fulfill());
  }
}

export function* loadMoreCommentsSaga({ payload }) {
  const { context, contextId, paginationParams, callbackFn } = payload;

  try {
    const response = yield call(
      request,
      `${VICE_URL}/comment?context=${context}&contextId=${contextId}&${qs.stringify(
        paginationParams
      )}`
    );
    yield put(
      loadMoreComments.success({
        response: response.data,
        order: paginationParams.order,
        context,
        contextId,
      })
    );
    if (callbackFn) {
      callbackFn({
        ...response.data,
        order: paginationParams.order,
        orderBy: paginationParams.orderBy,
        context,
        contextId,
      });
    }
  } catch (error) {
    yield put(loadMoreComments.failure({ error }));
  } finally {
    yield put(loadMoreComments.fulfill());
  }
}

export function* addCommentSaga({ payload }) {
  try {
    const { context, contextId, updatedComment, callbackFn } = payload;
    const response = yield call(request, `${VICE_URL}/comment`, {
      method: 'POST',
      payload: {
        context,
        contextId,
        comment: updatedComment,
      },
    });
    yield put(
      addComment.success({
        response: response.data,
        successMessage: SUCCESS_MESSAGES.ADD_COMMENT,
        context,
        contextId,
      })
    );

    if (callbackFn) callbackFn({ ...response.data, context, contextId });
  } catch (error) {
    yield put(addComment.failure({ error }));
  } finally {
    yield put(addComment.fulfill());
  }
}

export function* updateCommentSaga({ payload }) {
  try {
    const { commentId, updatedComment, callbackFn, context, contextId } =
      payload;
    const response = yield call(request, `${VICE_URL}/comment/${commentId}`, {
      method: 'PUT',
      payload: { comment: updatedComment },
    });
    yield put(
      updateComment.success({
        response: response.data,
        successMessage: SUCCESS_MESSAGES.UPDATE_COMMENT,
        context,
        contextId,
      })
    );

    if (callbackFn) callbackFn({ ...response.data, context, contextId });
  } catch (error) {
    yield put(
      updateComment.failure({
        error,
        contextId: payload.contextId,
        context: payload.context,
      })
    );
  } finally {
    yield put(updateComment.fulfill());
  }
}

export function* deleteCommentSaga({ payload }) {
  try {
    const { commentId, callbackFn, context, contextId } = payload;
    yield call(request, `${VICE_URL}/comment/${commentId}`, {
      method: 'DELETE',
    });
    yield put(
      deleteComment.success({
        commentId,
        successMessage: SUCCESS_MESSAGES.DELETE_COMMENT,
        context,
        contextId,
      })
    );

    if (callbackFn) callbackFn({ commentId, context, contextId });
  } catch (error) {
    yield put(
      deleteComment.failure({
        error,
        contextId: payload.contextId,
        context: payload.context,
      })
    );
  } finally {
    yield put(deleteComment.fulfill());
  }
}

export function* clearCommentsSaga({ payload }) {
  try {
    yield put(
      clearComments.success({
        context: payload.context,
        contextId: payload.contextId,
      })
    );
  } catch (error) {
    yield put(
      clearComments.failure({
        error,
        context: payload.context,
        contextId: payload.contextId,
      })
    );
  } finally {
    yield put(clearComments.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchComments.TRIGGER, fetchCommentBySourceIdSaga),
    takeLatest(loadMoreComments.TRIGGER, loadMoreCommentsSaga),
    takeEvery(addComment.TRIGGER, addCommentSaga),
    takeEvery(updateComment.TRIGGER, updateCommentSaga),
    takeEvery(deleteComment.TRIGGER, deleteCommentSaga),
    takeEvery(clearComments.TRIGGER, clearCommentsSaga),
  ]);
}
